import type * as React from 'react'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup, {
  toggleButtonGroupClasses
} from '@mui/material/ToggleButtonGroup'
import { type lookup } from '../../core/types'

const bgColor = 'rgba(113, 54, 188, 1)'
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '&.MuiToggleButtonGroup-root': {
    backgroundColor: bgColor
  },
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0
    }
  },
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    color: 'white',
    backgroundColor: bgColor,
    '&:hover': {
      color: 'white',
      backgroundColor: '#e4d1fd'
    },
    '&.Mui-selected': {
      backgroundColor: 'white',
      color: bgColor,
      '&:hover': {
        color: 'white',
        backgroundColor: '#e4d1fd'
      }

    }
  }
}))

export default function ButtonGroup (props: { value: number, options: lookup[], setValue: (newVal: number) => void }): JSX.Element {
  const handleChange = (
    event: any,
    newVal: number
  ): void => {
    props.setValue(newVal)
  }

  return (
    <div>
      <Paper
        elevation={0}
        sx={(theme) => ({
          display: 'flex',
          border: `1px solid ${theme.palette.divider}`,
          flexWrap: 'wrap'
        })}
      >
        <StyledToggleButtonGroup
          size="small"
          value={props.value}
          exclusive
          onChange={handleChange}
          aria-label="text alignment"
        >
          {props.options.map(o => {
            return <ToggleButton value={o.id}>
              {o.name}
            </ToggleButton>
          })}
        </StyledToggleButtonGroup>
      </Paper>
    </div>
  )
}
